<template>
    <div>
        <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons" v-if="filterHeading.length">
            {{filterHeading}}
        </div>
        <select name="" id="" @change="updateValue($event)" ref="input">
            <option value=''>Please select...</option>
            <option v-for="(key, value) in optionValues" :value="key">{{ value }}</option>
        </select>
    </div>
</template>

<script>

    export default {
        name: 'SelectFilter',
        props: {
            filterHeading: {
                type: String,
                default: ''
            },
            id: {
                type: Number,
                default: 0
            },
            name: {
                type: String,
                default: ''
            },
            optionValues: {
                type: Object,
                default: {},
            },
            // Callback
            update: {},
        },
        methods: {
            updateValue(event) {
                this.update({key: this.name, value: event.target.value});
            },
            reset() {
                this.update({key: this.name, value: null});
                this.$refs.input.value = '';
            },
        }
    }

</script>


// WEBPACK FOOTER //
// SelectFilter.vue?82936a4c